import { State, StateAction } from '@people-science/state-machine';
import { DynamicFormContextState } from '../../DynamicFormContext';
import { TransitionConditionPlugin } from '../TransitionConditionPlugin';

export enum DataConditionOperator {
  Equal = 'equal',
  NotEqual = 'not-equal',
  HasValue = 'has-value',
  ContainsValue = 'contains-value',
  GreaterThan = 'greater-than',
  LessThan = 'less-than'
}

export interface DataCondition {
  schemaColumnName: string;
  operator: DataConditionOperator;
  values?: (string | number | boolean)[];
}

export const DataConditionPlugin: TransitionConditionPlugin<DataCondition> = {
  type: 'Data Condition',
  validate: (condition: Partial<StateAction<DataCondition>>) => {
    return true;
  },
  guard: (
    state: State<DynamicFormContextState<any, any>>,
    params: DataCondition
  ) => {
    const value = state.context.formValues?.[params.schemaColumnName];
    switch (params?.operator) {
      case DataConditionOperator.HasValue:
        if (params.values && params.values.length > 0) {
          // check if at lease X number of items selected
          return Array.isArray(value) && value.length >= +params.values;
        } else if (Array.isArray(value)) {
          return value.length > 0;
        } else {
          return typeof value !== 'undefined';
        }
      case DataConditionOperator.ContainsValue: {
        const values = Array.isArray(value) ? value : [value];
        const paramValues = params.values || [];
        return paramValues.every(pv => values.some(value => value === pv));
      }
      case DataConditionOperator.NotEqual: {
        const values = Array.isArray(value) ? value : [value];
        if (values.length === 0) return false;
        for (const value of values) {
          for (const paramValue of params.values || []) {
            // using non-strict equality
            if (paramValue == value) {
              return false;
            }
          }
        }
        return true;
      }
      case DataConditionOperator.GreaterThan:
        return value > +(params.values?.[0] || 0);
      case DataConditionOperator.LessThan:
        return value < +(params.values?.[0] || 0);
      default: {
        const values = Array.isArray(value) ? value : [value];
        if (values.length === 0) return false;
        for (const value of values) {
          for (const paramValue of params.values || []) {
            // using non-strict equality
            if (paramValue != value) {
              return false;
            }
          }
        }
        return true;
      }
    }
  }
};
